import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <div className="min-h-screen flex flex-col" data-id="element-298">
      {/* Navigation */}
      <header className="fixed top-0 left-0 right-0 z-[1000] bg-[#F1F5F9]/80 backdrop-blur-xl border-b border-[#0F172A]/[0.08]" data-id="element-299">
        <div className="flex items-center justify-between py-4 max-w-[1200px] mx-auto px-6" data-id="element-300">
          <a href="#" className="flex items-center gap-2 font-heading text-2xl font-bold text-[#0F172A] no-underline" data-id="element-301">
            <img src="https://assets.corkship.io/CorkShip%20Logo%20Original%20png.png" alt="CorkShip Logo" className="w-10 h-10 object-contain" data-id="element-302" />
            CorkShip
          </a>
          <nav className="flex items-center gap-8" data-id="element-303">
            <ul className="hidden md:flex gap-6 list-none m-0 p-0" data-id="element-304">
              <li data-id="element-305"><a href="#features" className="font-medium text-[15px] text-[#0F172A] hover:text-[#0284C7] transition-colors no-underline" data-id="element-306">Features</a></li>
              <li data-id="element-307"><a href="#how-it-works" className="font-medium text-[15px] text-[#0F172A] hover:text-[#0284C7] transition-colors no-underline" data-id="element-308">How It Works</a></li>
              <li data-id="element-309"><a href="#pricing" className="font-medium text-[15px] text-[#0F172A] hover:text-[#0284C7] transition-colors no-underline" data-id="element-310">Pricing</a></li>
              <li data-id="element-311"><Link to="/docs/commerce7" className="font-medium text-[15px] text-[#0F172A] hover:text-[#0284C7] transition-colors no-underline" data-id="element-312">Docs</Link></li>
            </ul>
            <div className="hidden md:flex gap-4 items-center" data-id="element-313">
              <a href="#" className="inline-flex items-center gap-2 bg-[#0284C7] text-white px-5 py-2.5 rounded-lg text-sm font-semibold no-underline transition-all hover:bg-[#0369A1]" data-id="element-314">Launching Soon</a>
            </div>
          </nav>
        </div>
      </header>

      {/* Hero */}
      <section className="min-h-screen flex items-center pt-[120px] pb-20 bg-[#F1F5F9] relative overflow-hidden" data-id="element-315">
        <div className="absolute top-0 right-0 w-[60%] h-full bg-gradient-to-br from-transparent via-[#0284C7]/[0.03] to-[#7DD3FC]/[0.08] [clip-path:polygon(20%_0,100%_0,100%_100%,0%_100%)]" data-id="element-316"></div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center relative z-10 max-w-[1200px] mx-auto px-6" data-id="element-317">
          <div data-id="element-318">
            <div className="inline-flex items-center gap-2 bg-[#0284C7]/10 text-[#0284C7] px-4 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-319">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-320"><circle cx="12" cy="12" r="10" data-id="element-321" /><path d="M12 6v6l4 2" data-id="element-322" /></svg>
              Built for Australian Wineries
            </div>
            <h1 className="font-heading text-[clamp(2.5rem,5vw,4rem)] font-bold text-[#0F172A] mb-6 leading-[1.2]" data-id="element-323">
              Wine Shipping<br data-id="element-324" />
              <span className="bg-gradient-to-r from-[#0284C7] to-[#7DD3FC] bg-clip-text text-transparent" data-id="element-325">Made Simple</span>
            </h1>
            <p className="text-lg text-[#64748B] mb-8 max-w-[480px] leading-[1.7]" data-id="element-326">The only fulfilment app designed specifically for wineries. Smart parcel assignment, Australia Post integration, and wine-compliant shipping in minutes.</p>
            <div className="flex gap-4 flex-wrap mb-4" data-id="element-327">
              <a href="#" className="inline-flex items-center gap-2 bg-[#0284C7] text-white px-7 py-3.5 rounded-lg font-semibold no-underline transition-all hover:bg-[#0369A1] hover:-translate-y-0.5 shadow-[0_4px_14px_rgba(2,132,199,0.4)]" data-id="element-328">
                Launching Soon
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-329"><path d="M5 12h14" data-id="element-330" /><path d="M12 5l7 7-7 7" data-id="element-331" /></svg>
              </a>
              <a href="https://www.youtube.com/watch?v=MQLSd61omUA" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-transparent text-[#0284C7] px-7 py-3.5 rounded-lg font-semibold no-underline border-2 border-[#0284C7] transition-all hover:bg-[#0284C7]/10 hover:-translate-y-0.5" data-id="element-332">Watch Demo</a>
            </div>
            <div className="flex items-center gap-2 text-sm text-[#64748B] mb-12" data-id="element-333">
              <span data-id="element-334">Available for</span>
              <span className="inline-flex items-center gap-1.5 text-[#0F172A] font-medium" data-id="element-335">
                <svg viewBox="0 0 24 24" fill="#5E8E3E" className="w-4 h-4" data-id="element-336"><path d="M15.337 3.415c-.157-.018-.314.064-.392.203-.078.14-.048.317.073.427.744.683 1.18 1.595 1.18 2.455 0 1.903-1.627 3.5-3.5 3.5s-3.5-1.597-3.5-3.5c0-.86.436-1.772 1.18-2.455.12-.11.15-.287.072-.427-.078-.14-.235-.22-.392-.203C6.996 3.7 4.5 6.585 4.5 10c0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-3.415-2.496-6.3-4.163-6.585z" data-id="element-337" /></svg>
                Shopify
              </span>
              <span className="text-[#CBD5E1]" data-id="element-338">and</span>
              <span className="inline-flex items-center gap-1.5 text-[#0F172A] font-medium" data-id="element-339">
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none" data-id="element-340"><circle cx="12" cy="12" r="10" fill="#6B21A8" data-id="element-341" /><text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold" data-id="element-342">C7</text></svg>
                Commerce7
              </span>
            </div>
            <div className="flex gap-12 pt-8 border-t border-[#0F172A]/10" data-id="element-343">
              <div data-id="element-344"><div className="font-heading text-[2rem] font-bold text-[#0F172A]" data-id="element-345">3min</div><div className="text-sm text-[#64748B]" data-id="element-346">Average setup time</div></div>
              <div data-id="element-347"><div className="font-heading text-[2rem] font-bold text-[#0F172A]" data-id="element-348">50%</div><div className="text-sm text-[#64748B]" data-id="element-349">Less shipping errors</div></div>
              <div data-id="element-350"><div className="font-heading text-[2rem] font-bold text-[#0F172A]" data-id="element-351">24/7</div><div className="text-sm text-[#64748B]" data-id="element-352">Order processing</div></div>
            </div>
          </div>
          <div data-id="element-353">
            <div className="bg-white rounded-3xl p-8 shadow-[0_25px_50px_-12px_rgba(0,0,0,0.1)] border border-[#0F172A]/[0.05]" data-id="element-354">
              <div className="flex items-center justify-between mb-6 pb-4 border-b border-[#E2E8F0]" data-id="element-355">
                <h3 className="font-body text-base font-semibold text-[#0F172A] flex items-center gap-2" data-id="element-356">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-357"><rect x="2" y="7" width="20" height="14" rx="2" data-id="element-358" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-359" /></svg>
                  Order Pipeline
                </h3>
                <span className="bg-[#D1FAE5] text-[#059669] px-3 py-1 rounded-full text-xs font-semibold" data-id="element-360">Australia Post Connected</span>
              </div>
              <div className="flex items-center justify-between mb-8 relative" data-id="element-361">
                <div className="absolute top-6 left-10 right-10 h-0.5 bg-gradient-to-r from-[#10B981] from-0% via-[#10B981] via-20% to-[#E2E8F0] to-20% z-0" data-id="element-362"></div>
                {[{
                label: 'Pending',
                done: true,
                active: false
              }, {
                label: 'Shipment Created',
                done: false,
                active: true
              }, {
                label: 'Labels Generated',
                done: false,
                active: false
              }, {
                label: 'Manifested',
                done: false,
                active: false
              }, {
                label: 'Delivered',
                done: false,
                active: false
              }].map(step => <div key={step.label} className="flex flex-col items-center gap-2 relative z-10" data-id="element-363">
                    <div className={`w-12 h-12 rounded-xl flex items-center justify-center border-2 ${step.done ? 'bg-[#D1FAE5] border-[#10B981] text-[#059669]' : step.active ? 'bg-[#DBEAFE] border-[#0284C7] text-[#0284C7] shadow-[0_0_0_4px_rgba(2,132,199,0.15)]' : 'bg-[#F1F5F9] border-[#E2E8F0] text-[#64748B]'}`} data-id="element-364">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5" data-id="element-365"><rect x="2" y="7" width="20" height="14" rx="2" data-id="element-366" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-367" /></svg>
                    </div>
                    <span className={`text-[11px] font-medium text-center max-w-[60px] ${step.done ? 'text-[#059669]' : step.active ? 'text-[#0284C7] font-semibold' : 'text-[#64748B]'}`} data-id="element-368">{step.label}</span>
                  </div>)}
              </div>
              <div className="flex flex-col gap-3" data-id="element-369">
                {[{
                num: '#1247',
                dest: 'Yarra Valley VIC',
                desc: 'Mixed case — 6kg',
                bottles: 12,
                color: '#0284C7'
              }, {
                num: '#1246',
                dest: 'Bondi NSW',
                desc: 'Shiraz 2022 — 4kg',
                bottles: 6,
                color: '#F59E0B'
              }, {
                num: '#1245',
                dest: 'Adelaide SA',
                desc: 'Wine club — 18kg',
                bottles: 24,
                color: '#10B981'
              }].map(o => <div key={o.num} className="flex items-center gap-4 p-3.5 bg-[#F8FAFC] rounded-[10px] border border-[#E2E8F0]" data-id="element-370">
                    <div className="w-2 h-2 rounded-full flex-shrink-0" style={{
                  backgroundColor: o.color
                }} data-id="element-371"></div>
                    <div className="flex-1" data-id="element-372">
                      <div className="text-[13px] font-semibold text-[#0F172A]" data-id="element-373">{o.num} · {o.dest}</div>
                      <div className="text-xs text-[#64748B]" data-id="element-374">{o.desc}</div>
                    </div>
                    <span className="bg-[#0284C7]/10 text-[#0284C7] px-2.5 py-1 rounded-md text-[11px] font-semibold" data-id="element-375">{o.bottles} bottles</span>
                  </div>)}
              </div>
              <div className="flex items-center gap-2 mt-5 pt-4 border-t border-[#E2E8F0]" data-id="element-376">
                <span className="flex items-center gap-1.5 bg-[#0284C7] text-white px-4 py-2 rounded-lg text-xs font-semibold" data-id="element-377">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-378"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" data-id="element-379" /><polyline points="14 2 14 8 20 8" data-id="element-380" /></svg>
                  Generate Labels
                </span>
                <span className="text-xs text-[#64748B]" data-id="element-381">One click to create shipping labels</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section id="features" className="py-24 relative bg-gradient-to-b from-white to-[#F1F5F9]" data-id="element-382">
        <div className="container mx-auto px-6" data-id="element-383">
          <div className="text-center max-w-[600px] mx-auto mb-12" data-id="element-384">
            <h2 className="font-heading text-[clamp(1.75rem,3vw,2.5rem)] text-[#0F172A] mb-4" data-id="element-385">Everything You Need to Ship Wine</h2>
            <p className="text-[#64748B] text-lg" data-id="element-386">Purpose-built features that understand the unique requirements of wine fulfilment.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-387">
            {[{
            title: 'Smart Parcel Assignment',
            desc: 'Automatically calculates optimal packaging based on bottle count. Supports 1, 2, 3, 6, and 12-pack configurations.'
          }, {
            title: 'One-Click Labels',
            desc: 'Generate Australia Post shipping labels instantly. Choose from thermal or A4 formats with automatic tracking sync.'
          }, {
            title: 'Customer Tracking Notifications',
            desc: 'Your customers stay informed at every step. Automatic tracking emails from dispatch to delivery.',
            highlight: true
          }, {
            title: 'Age Verification',
            desc: 'Automatic ID25 age verification on all wine shipments. Built-in compliance for recipients over 18.'
          }, {
            title: 'Address Validation',
            desc: 'Real-time Australia Post address verification catches errors before shipping.'
          }, {
            title: 'Manifest Management',
            desc: 'Batch shipments into manifests for Australia Post pickup with order summary PDFs.'
          }].map(f => <div key={f.title} className={`group relative rounded-xl p-8 shadow-sm border transition-all duration-300 hover:-translate-y-1 hover:shadow-xl overflow-hidden ${f.highlight ? 'border-[#0284C7]/15 bg-gradient-to-br from-[#0284C7]/[0.03] to-[#7DD3FC]/[0.08]' : 'bg-white border-slate-900/5'}`} data-id="element-388">
                <div className={`absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#0284C7] to-[#7DD3FC] ${f.highlight ? '' : 'scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left'}`} data-id="element-389"></div>
                <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-[#0284C7]/10 to-[#7DD3FC]/10 flex items-center justify-center mb-6 text-[#0284C7]" data-id="element-390">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-6 h-6" data-id="element-391"><rect x="2" y="7" width="20" height="14" rx="2" data-id="element-392" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" data-id="element-393" /></svg>
                </div>
                {f.highlight && <div className="inline-flex items-center gap-1.5 bg-emerald-500/10 text-emerald-600 px-2.5 py-1 rounded-full text-xs font-semibold mb-3" data-id="element-394">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-395"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" data-id="element-396" /><polyline points="22 4 12 14.01 9 11.01" data-id="element-397" /></svg>
                    Customer Favourite
                  </div>}
                <h3 className="text-xl font-heading font-bold text-[#0F172A] mb-2" data-id="element-398">{f.title}</h3>
                <p className="text-gray-600 text-[15px] leading-relaxed" data-id="element-399">{f.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="py-24 bg-[#0F172A] text-white relative overflow-hidden" data-id="element-400">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] opacity-30 pointer-events-none" data-id="element-401">
          <div className="w-full h-full rounded-full bg-gradient-to-br from-[#0284C7]/50 to-transparent blur-3xl" data-id="element-402"></div>
        </div>
        <div className="container mx-auto px-6 relative z-10" data-id="element-403">
          <div className="text-center max-w-[600px] mx-auto mb-12" data-id="element-404">
            <h2 className="font-heading text-[clamp(1.75rem,3vw,2.5rem)] text-white mb-4" data-id="element-405">From Order to Delivery in Four Steps</h2>
            <p className="text-white/70 text-lg" data-id="element-406">Streamlined workflow designed for busy cellar doors and wine clubs.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6" data-id="element-407">
            {[{
            n: '1',
            title: 'Connect',
            desc: 'Link your store and Australia Post account in minutes. No technical setup required.',
            connector: true
          }, {
            n: '2',
            title: 'Review',
            desc: 'Orders appear automatically with smart parcel suggestions. Adjust weights and packaging as needed.',
            connector: true
          }, {
            n: '3',
            title: 'Print',
            desc: 'Generate shipping labels with one click. Download PDFs ready for your thermal or desktop printer.',
            connector: true
          }, {
            n: '4',
            title: 'Ship',
            desc: "Create manifests and hand parcels to Australia Post. Track deliveries to the customer's door.",
            connector: false
          }].map(step => <div key={step.n} className="text-center relative" data-id="element-408">
                <div className="relative inline-block mb-6" data-id="element-409">
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-[#0284C7] to-[#7DD3FC] flex items-center justify-center font-heading text-2xl font-bold text-[#0F172A] shadow-lg shadow-[#0284C7]/40 relative z-10" data-id="element-410">{step.n}</div>
                  {step.connector && <div className="hidden lg:block absolute top-1/2 left-[calc(100%+0.5rem)] w-[calc(100vw/4-5rem)] h-0.5 bg-gradient-to-r from-[#0284C7] to-[#7DD3FC] opacity-30 -translate-y-1/2" data-id="element-411"></div>}
                </div>
                <h3 className="font-heading text-xl font-bold text-white mb-2" data-id="element-412">{step.title}</h3>
                <p className="text-white/70 text-[15px] leading-relaxed" data-id="element-413">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* Pricing */}
      <PricingSection data-id="element-414" />

      {/* CTA */}
      <section className="py-24 bg-white" data-id="element-415">
        <div className="container mx-auto px-6" data-id="element-416">
          <div className="bg-[#0F172A] rounded-3xl p-12 md:p-20 text-center relative overflow-hidden" data-id="element-417">
            <div className="absolute top-0 right-0 w-full h-full bg-[url('https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')] bg-cover bg-center opacity-10 mix-blend-overlay" data-id="element-418"></div>
            <div className="relative z-10 max-w-3xl mx-auto" data-id="element-419">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-420">Ship your first order in under 5 minutes</h2>
              <p className="text-lg text-blue-100 mb-10" data-id="element-421">Connect your store and Australia Post account — start shipping today.</p>
              <a href="#" className="inline-flex items-center gap-2 bg-[#FCD34D] text-[#0F172A] px-7 py-3.5 rounded-lg font-semibold no-underline transition-all hover:bg-yellow-300 border-none shadow-lg shadow-yellow-400/20" data-id="element-422">Launching Soon</a>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-423" />
    </div>;
}
function PricingSection() {
  const plans = [{
    platform: 'Shopify',
    platformIcon: <svg viewBox="0 0 24 24" fill="#5E8E3E" className="w-5 h-5" data-id="element-424">
          <path d="M15.337 3.415c-.157-.018-.314.064-.392.203-.078.14-.048.317.073.427.744.683 1.18 1.595 1.18 2.455 0 1.903-1.627 3.5-3.5 3.5s-3.5-1.597-3.5-3.5c0-.86.436-1.772 1.18-2.455.12-.11.15-.287.072-.427-.078-.14-.235-.22-.392-.203C6.996 3.7 4.5 6.585 4.5 10c0 4.136 3.364 7.5 7.5 7.5s7.5-3.364 7.5-7.5c0-3.415-2.496-6.3-4.163-6.585z" data-id="element-425" />
        </svg>,
    price: '$14.99',
    currency: 'USD',
    badge: null
  }, {
    platform: 'Commerce7',
    platformIcon: <svg viewBox="0 0 24 24" className="w-5 h-5" fill="none" data-id="element-426">
          <circle cx="12" cy="12" r="10" fill="#6B21A8" data-id="element-427" />
          <text x="12" y="16" textAnchor="middle" fill="white" fontSize="10" fontWeight="bold" data-id="element-428">C7</text>
        </svg>,
    price: '$19.99',
    currency: 'AUD',
    badge: 'New'
  }];
  const features = ['Unlimited shipments', 'Smart parcel assignment', 'PDF label generation', 'Address validation', 'Postcode validation rules', 'Checkout validation', 'Manifest management', 'Email support'];
  return <section className="py-24 bg-[#F1F5F9]" id="pricing" data-id="element-429">
      <div className="max-w-[1200px] mx-auto px-6" data-id="element-430">
        <div className="text-center max-w-[600px] mx-auto mb-12" data-id="element-431">
          <h2 className="font-heading text-[clamp(1.75rem,3vw,2.5rem)] text-[#0F172A] mb-4" data-id="element-432">Simple, Transparent Pricing</h2>
          <p className="text-[#64748B] text-lg" data-id="element-433">No per-label fees. No hidden costs. Just straightforward monthly pricing.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[860px] mx-auto" data-id="element-434">
          {plans.map(plan => <div key={plan.platform} className="bg-[#0F172A] text-[#F8FAFC] rounded-3xl p-10 relative shadow-[0_25px_50px_rgba(15,23,42,0.2)]" data-id="element-435">
              {plan.badge && <div className="absolute -top-3 left-6 bg-gradient-to-r from-[#6B21A8] to-[#9333EA] text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase" data-id="element-436">
                  {plan.badge}
                </div>}
              <div className="flex items-center gap-2 mb-6 pb-6 border-b border-white/10" data-id="element-437">
                {plan.platformIcon}
                <span className="font-heading text-xl font-bold" data-id="element-438">{plan.platform}</span>
              </div>
              <div className="mb-1" data-id="element-439">
                <span className="font-heading text-[3.5rem] font-bold leading-none" data-id="element-440">{plan.price}</span>
                <span className="text-lg opacity-60 ml-1" data-id="element-441">{plan.currency}</span>
              </div>
              <div className="text-[15px] opacity-60 mb-8" data-id="element-442">per month</div>
              <ul className="list-none space-y-2.5 mb-8" data-id="element-443">
                {features.map(f => <li key={f} className="flex items-center gap-3 text-[15px]" data-id="element-444">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-5 h-5 text-[#7DD3FC] flex-shrink-0" data-id="element-445"><polyline points="20 6 9 17 4 12" data-id="element-446" /></svg>
                    {f}
                  </li>)}
              </ul>
              <a href="#" className="w-full bg-white text-[#0F172A] px-8 py-4 rounded-lg text-base font-semibold no-underline inline-block text-center transition-all hover:bg-[#7DD3FC]" data-id="element-447">Launching Soon</a>
            </div>)}
        </div>

        <p className="text-center mt-6 text-sm text-[#64748B]" data-id="element-448">
          Prices shown are per store, per month. All plans include full access to every feature.
        </p>
      </div>
    </section>;
}
export default HomePage;